import { Routes } from '@angular/router';

import { applicationRouteNames } from './app/application-route-names';
import { applicationRoutes } from './app/application.routes';
import { mpsRoutes } from './mps/routes/mps.routes';

export const globalRoutes: Routes = [
  ...applicationRoutes,
  ...mpsRoutes,
  { path: '**', redirectTo: applicationRouteNames.ingredients, pathMatch: 'full' },
];
